// @/pinia/payments.module.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getCurrentInstance } from 'vue';
import { useToast } from 'vue-toast-notification';
import { useLoadingStore } from '@/pinia/loading.module';
import { useAuthStore } from '@/pinia/auth.module';
import { getLocaleMessage } from '@/services/MessagesService';
import { getNestedValue } from '@/helpers/sort';
import * as service from '@/services';

const $toast = useToast();

export const usePaymentsStore = defineStore('payments', () => {
    // State
    const isModalOpen = ref(false)
    const payments = ref([])
    const currentPayment = ref(null)
    const isLoading = ref(false)
    const error = ref(null)

    // Getters
    const getModalStatus = computed(() => isModalOpen.value)
    const getAllPayments = computed(() => payments.value)
    const getCurrentPayment = computed(() => currentPayment.value)
    const getLoadingState = computed(() => isLoading.value)
    const getError = computed(() => error.value)

    // Actions
    const setModalStatus = (status) => {
        isModalOpen.value = status
    }

    const addPayment = async (paymentData) => {
        isLoading.value = true
        error.value = null
        
        try {
            const { data } = await service.quotationsApi.post(`/api/Payment`, paymentData);
            if (data) {
                    console.log("API: ", data);
                    // const result = data.data;
                    const result = data;
                    $toast.success("Pago registrado con exito.");
                    return result;
                }
        } catch (err) {
            error.value = err.message || 'Ocurrió un error al generar el registro del pago.'
            $toast.error("Ocurrió un error al generar el registro del pago.");
            throw err
        } finally {
            isLoading.value = false
        }
    }

    const fetchPayments = async () => {
        isLoading.value = true
        error.value = null
        
        try {
            // Simular llamada a API
            await new Promise(resolve => setTimeout(resolve, 800))
            
            // Datos de ejemplo
            payments.value = [
                {
                    id: 1,
                    paymentNumber: 'PAY-001',
                    prospectName: 'Juan Pérez',
                    amount: 1500.00,
                    paymentDate: '2024-01-15',
                    status: 'completed',
                    paymentMethod: 'transfer',
                    referenceNumber: 'REF-001'
                },
                {
                    id: 2,
                    paymentNumber: 'PAY-002', 
                    prospectName: 'María García',
                    amount: 2000.00,
                    paymentDate: '2024-01-14',
                    status: 'pending',
                    paymentMethod: 'cash',
                    referenceNumber: 'REF-002'
                }
            ]
        } catch (err) {
            error.value = 'Error al cargar los pagos'
            console.error('Error fetching payments:', err)
        } finally {
            isLoading.value = false
        }
    }

    const clearError = () => {
        error.value = null
    }

    const reset = () => {
        payments.value = []
        currentPayment.value = null
        isLoading.value = false
        error.value = null
        isModalOpen.value = false
    }

    return {
        // State
        isModalOpen,
        payments,
        currentPayment,
        isLoading,
        error,
        
        // Getters
        getModalStatus,
        getAllPayments,
        getCurrentPayment,
        getLoadingState,
        getError,
        
        // Actions
        setModalStatus,
        addPayment,
        fetchPayments,
        clearError,
        reset
    }
})